import App, { BypassApp } from './App.tsx'
import { ErrorScreen } from '@/components/feedback/ErrorScreen'
import { getDevBypassSubscription } from '@/lib/devBypass'
import { AppEnvNotInjectedError, getAppEnv } from '@/lib/env'

export function Root() {
  try {
    getAppEnv()
  } catch (err) {
    if (err instanceof AppEnvNotInjectedError) {
      return <ErrorScreen reason="config-missing" onRetry={() => window.location.reload()} />
    }
    throw err
  }
  const bypass = getDevBypassSubscription()
  return bypass ? <BypassApp bypass={bypass} /> : <App />
}
